__turbopack_context__.v({
  "button": "OurJourneyNav-module-scss-module__3yp-Ba__button",
  "fade-in": "OurJourneyNav-module-scss-module__3yp-Ba__fade-in",
  "indicator": "OurJourneyNav-module-scss-module__3yp-Ba__indicator",
  "indicatorContainer": "OurJourneyNav-module-scss-module__3yp-Ba__indicatorContainer",
  "inner": "OurJourneyNav-module-scss-module__3yp-Ba__inner",
  "item": "OurJourneyNav-module-scss-module__3yp-Ba__item",
  "label": "OurJourneyNav-module-scss-module__3yp-Ba__label",
  "labelInner": "OurJourneyNav-module-scss-module__3yp-Ba__labelInner",
  "list": "OurJourneyNav-module-scss-module__3yp-Ba__list",
  "root": "OurJourneyNav-module-scss-module__3yp-Ba__root",
});
